module.exports = __webpack_public_path__ + "img/nav-dashboard.0c5f31ef.svg";